export function formatPrice(value: number) {
    return (value / 100).toFixed(2);
}
